/**
 * OfflineBanner - Bannière affichée quand l'utilisateur est hors ligne
 */
import React, { useState, useEffect } from 'react';
import { WifiOff, X } from '../lib/icons';

const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [dismissed, setDismissed] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBanner(false);
      setDismissed(false);
    };
    
    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
      setDismissed(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Initial check
    if (!navigator.onLine) {
      setShowBanner(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline || dismissed) return null;

  return (
    <div 
      className={`offline-banner ${showBanner ? 'visible' : ''}`}
      role="alert"
      data-testid="offline-banner"
    >
      <div className="flex items-center justify-center gap-2">
        <WifiOff className="w-4 h-4" />
        <span>Vous êtes hors ligne. Les modifications seront synchronisées automatiquement.</span>
        <button
          onClick={() => setDismissed(true)}
          className="ml-2 p-1 rounded-full hover:bg-white/20 transition-colors"
          aria-label="Fermer"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default OfflineBanner;
